<template>
  <li class="accordion--item">
    <div
      class="accordion--trigger"
      :class="{ accordion__trigger_active: visible }"
      @click="toggleItem"
    >
      <slot name="accordion-trigger"></slot>
      <LsIcon type="chevron" color="primary" size="md" :style="chevronRotationStyle" />
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div v-show="visible" class="accordion--content">
        <ul>
          <slot name="accordion-content"></slot>
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
import LsIcon from '@/components/common/LsIcon/LsIcon.vue';

export default {
  components: {
    LsIcon,
  },
  props: {},
  inject: ['Accordion'],
  data() {
    return {
      index: null,
    };
  },
  computed: {
    chevronRotationStyle() {
      return {
        transform: `rotate(${this.visible ? 0.75 : 0.25}turn)`,
      };
    },
    visible() {
      return this.index === this.Accordion.active;
    },
  },
  created() {
    this.index = this.Accordion.count++;
  },
  methods: {
    toggleItem() {
      this.Accordion.active = !this.visible ? this.index : null;
    },
    start(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    end(el) {
      el.style.height = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion--item {
  cursor: pointer;
  padding: 10px 0;
  border-bottom: 1px solid $primary-light;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  &__item:last-child {
    border-bottom: none;
  }
}

.accordion--content {
  margin-top: 8px;
}

.accordion--trigger {
  display: flex;
  justify-content: space-between;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
